module.exports = __webpack_public_path__ + "media/home_hero-800.d7c31a9c.webm";